import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';

const AddressContact = ({
  heading1 = 'Contact Us',
  content1 = 'Have questions? We have answers.',
  location2 = 'Headquarters',
  location2Description = `
    Robomec Automation Private Limited,
    B133, Opp Sukrut Company, Near Bharat Petroleum Pump,
    Bhambholi, Chakan, Pune 410501, INDIA
  `,
  googleMapEmbedUrl = 'https://www.google.com/maps/embed?pb=!1m16!1m10!1m3!1d801.6585046262398!2d73.7883239!3d18.79193739833632!2m1!2f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b5934b2a269f%3A0xef0be3e9b628ca4!2sRoboMec%20Automation!5e1!3m2!1sde!2sde!4v1736848238387!5m2!1sde!2sde',
  rootClassName = '',
}) => {
  return (
    <Container className={`py-3 ${rootClassName}`} style={{ maxWidth: '1140px' }}>
      {/* Contact Section */}
      <Row className="mb-4 text-center">
        <Col>
          <h2 className="mb-3">{heading1}</h2>
          <p>
            {content1}{' '}
            <Link to="/contact-us" className="text-primary fw-bold text-decoration-underline">
              Reach out now!
            </Link>
          </p>
        </Col>
      </Row>

      {/* Address and Map Section */}
      <Row className="align-items-center">
        <Col md={6} className="mb-4 mb-md-0">
          <div style={{ width: '100%', height: '300px', borderRadius: '10px', overflow: 'hidden' }}>
            <iframe
              src={googleMapEmbedUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map Location"
            ></iframe>
          </div>
        </Col>
        <Col md={6} className="text-center text-md-start">
          <h3 className="mb-3">{location2}</h3>
          <p className="mb-4">{location2Description}</p>
          <Button
            href="https://maps.app.goo.gl/HjTGvB4Tih6k93Jz9"
            target="_blank"
            rel="noopener noreferrer"
            variant="primary"
          >
            Get directions
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

AddressContact.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
  location2: PropTypes.string,
  location2Description: PropTypes.string,
  googleMapEmbedUrl: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default AddressContact;
